import PropTypes from 'prop-types';

export default PropTypes.shape({
  bookingReference: PropTypes.string,
  createdAt: PropTypes.string,
  points: PropTypes.number,
  description: PropTypes.string
});
